import * as defaultImport from "@splunk/datasources/CloudSearch";
export * from "@splunk/datasources/CloudSearch";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
